import * as THREE from 'three';
import { textTexture } from './textures';
import { lantern } from './Particles';

/** v0.11: cờ / băng rôn có chữ (bang vô địch tuần…) – cột gỗ + lá cờ đung đưa. setText để đổi chữ. */
export class Banner {
  readonly group = new THREE.Group(); private cloth: THREE.Mesh; private mat: THREE.MeshBasicMaterial; private t = 0;
  constructor(private color = '#8a1f16') {
    const pole = new THREE.Mesh(new THREE.CylinderGeometry(0.08, 0.1, 6, 8), new THREE.MeshStandardMaterial({ color: '#3a2416' })); pole.position.y = 3; this.group.add(pole);
    const tip = new THREE.Mesh(new THREE.ConeGeometry(0.16, 0.4, 8), new THREE.MeshStandardMaterial({ color: '#d4a040', metalness: 0.6 })); tip.position.y = 6.2; this.group.add(tip);
    this.mat = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });
    this.cloth = new THREE.Mesh(new THREE.PlaneGeometry(2.6, 1.6, 8, 1), this.mat); this.cloth.position.set(1.4, 5, 0); this.group.add(this.cloth);
    this.group.visible = false;
  }
  setText(lines: string[] | null) {
    if (!lines) { this.group.visible = false; return; }
    this.mat.map?.dispose(); this.mat.map = textTexture(lines, { w: 512, h: 320, color: '#ffe7a8', bg: this.color, font: '700 54px "Noto Serif", Georgia, serif' }); this.mat.needsUpdate = true; this.group.visible = true;
  }
  update(dt: number) {
    if (!this.group.visible) return; this.t += dt; const pos = (this.cloth.geometry as THREE.PlaneGeometry).attributes.position as THREE.BufferAttribute;
    for (let i = 0; i < pos.count; i++) { const x = pos.getX(i) + 1.3; pos.setZ(i, Math.sin(this.t * 3 + x * 2) * 0.12 * x); } pos.needsUpdate = true;
  }
}

/** v0.11: trang trí ngày Rằm / Mùng Một – chùm đèn lồng bay lơ lửng quanh một khu (bật/tắt). */
export class FestivalDecor {
  readonly group = new THREE.Group(); private items: Array<{ l: { group: THREE.Group; update: (t: number) => void }; y: number; ph: number }> = [];
  constructor(spots: Array<[number, number, number]>, colors = ['#ff5a2a', '#ffd23a', '#ff8ac0']) {
    spots.forEach(([x, y, z], i) => { const l = lantern(false, colors[i % colors.length]); l.group.scale.setScalar(0.7); l.group.position.set(x, y, z); this.group.add(l.group); this.items.push({ l, y, ph: i * 1.3 }); });
    this.group.visible = false;
  }
  setOn(on: boolean) { this.group.visible = on; }
  update(t: number) { if (!this.group.visible) return; for (const it of this.items) { it.l.group.position.y = it.y + Math.sin(t * 0.8 + it.ph) * 0.3; it.l.update(t); } }
}
